import Api from '@/services/API';
// Methods
import { getBrowser, getOS } from "@/utils/getUserInfos";

/**
 * @typedef {AuthRequest}
 */

export default class Auth extends Api {

    /**
   * @type {String}
   */
    static base = '/oauth/token'


/**
   * @type {String}
   */
  static resource = ''

    /**
       * @param {String} resource
       * @param {Object} options
       * @param {Object} http
       */
    constructor(resource, options = {}, http = null) {
        super(Auth.normalize(Auth.base, resource), options, http);
            }

    /**
   * @return {this}
   */
    static build() {
        return new this(this.resource);
    }

    login(username,password,captcha, remember=false, isIntegration = false, hashState = null) {                        
        let data = {
            username:username,
            password:password,
            captcha:captcha,
            grant_type: 'password',
            scope: '*',
            client_id:  isIntegration ? process.env.ALEXA_VUE_APP_OAUTH_CLIENT_id : process.env.VUE_APP_OAUTH_CLIENT_id,
            client_secret: isIntegration ? process.env.ALEXA_VUE_APP_OAUTH_CLIENT_SECRET : process.env.VUE_APP_OAUTH_CLIENT_SECRET,
            system_operational: getOS(),
            browser: getBrowser(),
            response_type: isIntegration ? 'code' : 'token',
            hash: hashState
        }

        return this.post('',data);
    }

    logout() {
        return this.post();
    }

}
